import { RECENTLY_VIEWED_MAX_ITEMS } from './constants';

export const parseRecentlyViewed = (
  cookieValue: string | undefined
): string[] => {
  if (!cookieValue) return [];
  return cookieValue
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
    .slice(0, RECENTLY_VIEWED_MAX_ITEMS);
};

export const addToRecentlyViewed = (
  currentIds: string[],
  newId: string
): string[] => {
  const deduped = currentIds.filter((id) => id !== newId);
  return [newId, ...deduped].slice(0, RECENTLY_VIEWED_MAX_ITEMS);
};

export const serializeRecentlyViewed = (ids: string[]): string => {
  return ids.join(',');
};
